import { FaLightbulb, FaArrowRight, FaCalendar, FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import styles from './Blog.module.css';

const Blog = () => {
  const navigate = useNavigate();

  const handleBlogClick = (postId) => {
    navigate(`/blog/${postId}`);
  };

  const blogPosts = [
    {
      id: 1,
      title: "Las Últimas Tendencias en Desarrollo Web 2024",
      summary: "Descubre las tecnologías y tendencias que están definiendo el futuro del desarrollo web en este año.",
      image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
      category: "Desarrollo Web",
      author: "Carlos Martínez",
      date: "15 Enero 2024",
      readTime: "5 min"
    },
    {
        id: 1,
        title: "Las Últimas Tendencias en Desarrollo Web 2024",
        summary: "Descubre las tecnologías y tendencias que están definiendo el futuro del desarrollo web en este año.",
        image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
        category: "Desarrollo Web",
        author: "Carlos Martínez",
        date: "15 Enero 2024",
        readTime: "5 min"
    }
  ];

  return (
    <>
      <section className={styles.blogHero}>
        <div className={styles.heroContent}>
          <div className={styles.badge}>
            <FaLightbulb className={styles.badgeIcon} />
            <span>Nuestro Blog</span>
          </div>
          <h1>Ideas y <span>Conocimiento</span> Compartido</h1>
          <p>
            Explora nuestros artículos sobre tecnología, desarrollo y las últimas tendencias en el mundo digital.
          </p>
        </div>
      </section>

      <section className={styles.blogSection}>
        <div className={styles.blogContainer}>
          <div className={styles.blogGrid}>
            {blogPosts.map((post) => (
              <article 
                key={post.id} 
                className={styles.blogCard}
                onClick={() => handleBlogClick(post.id)}
              >
                <div className={styles.blogImage}>
                  <img src={post.image} alt={post.title} />
                  <div className={styles.blogOverlay}>
                    <FaArrowRight />
                  </div>
                </div>
                <div className={styles.blogInfo}>
                  <span className={styles.blogCategory}>{post.category}</span>
                  <h2>{post.title}</h2>
                  <p>{post.summary}</p>
                  <div className={styles.blogMeta}>
                    <div className={styles.metaItem}>
                      <FaUser />
                      <span>{post.author}</span>
                    </div>
                    <div className={styles.metaItem}>
                      <FaCalendar />
                      <span>{post.date}</span>
                    </div>
                  </div>
                  <button className={styles.readMore}>
                    Leer más <FaArrowRight />
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;